import React from 'react';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import moment from 'moment';
import EventBG from '../../../images/eventsIcons/Event_BG.jpg';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import {connect} from 'react-redux';
import './events.css';
import Loader from '../../../Helper/loader/loader';

const styles= theme =>({
    paper:{
        borderRadius:0,
        border:'1px solid lightgrey',
        overflow: 'unset'
    },
    eventContainer: {
        marginBottom:'2%'
    },
    eventListItem :{
        height: '2vh',
        alignItems:'flex-start',
        padding: '8px 6px'
    },
    eventListItemText: {
        color:'#b764ac',
        fontWeight:400,
        fontSize:'14px',
        paddingBottom:5,
        marginLeft:'-15px'
    },
    eventLocationListItemText:{
        color:'#b764ac',
        fontWeight:600,
        fontSize:'16px',
        padding:0,
        textOverflow:'ellipsis',
        overflow:'hidden',
        whiteSpace:'nowrap',
    },
    eventTextRoot:{
        padding:'8px 16px'
    },
    card: {
        maxWidth: 400,
    }
});

class EventWebView extends React.Component {
    constructor(props){
        super(props);
        this.state={
            data:{},
            anchorEl: null,
        }
    }

    handleClick = (event) => (e) => {
        this.setState({ anchorEl: e.currentTarget,data:event });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    handleEdit = () => {
        this.props.onEdit({...this.state.data});
        this.setState({ anchorEl: null });
    };

    handleDelete = () => {
        this.props.onDelete(this.state.data);
        this.setState({ anchorEl: null });
    };

    render(){
        const { classes,ownEvents } = this.props;
        const { anchorEl } = this.state;
        return(
            <Card
                header={<h3 className="h3">Edit your Events</h3>}
                CardHeaderProps={{
                    style: {paddingTop: 0, paddingBottom: 0},
                }}
                content={
                    <div className='event-list-web' onScroll={this.props.eventAppScroll}>
                        <Grid container spacing={24}>
                            {
                                ownEvents.EventDetailData !== null && ownEvents.EventDetailData.map((event, index) => {
                                    return (
                                        <Grid item sm={6} xs={12} key={index}>
                                            <Card
                                                paperClasses={classes.paper}
                                                header={<h4>{event.Name}</h4>}
                                                CardHeaderProps={{
                                                    style:{paddingTop:'4px',paddingBottom:0},
                                                    action: (
                                                        <div>
                                                            <IconButton
                                                                aria-label="More"
                                                                aria-owns={anchorEl ? 'long-menu' : null}
                                                                aria-haspopup="true"
                                                                onClick={this.handleClick(event)}
                                                            >
                                                                <MoreVertIcon/>
                                                            </IconButton>
                                                            <Menu
                                                                id='long-menu'
                                                                anchorEl={anchorEl}
                                                                open={Boolean(anchorEl)}
                                                                onClose={this.handleClose}
                                                                PaperProps={{
                                                                    style: {
                                                                        maxHeight: 48 * 4.5,
                                                                        width: 200
                                                                    }
                                                                }}
                                                            >
                                                                <MenuItem onClick={this.handleEdit}
                                                                          className="evenlist-option-text">Edit</MenuItem>
                                                                <MenuItem onClick={this.handleDelete}
                                                                          className="evenlist-option-text">Delete</MenuItem>
                                                            </Menu>
                                                        </div>
                                                    )
                                                }}
                                                CardContentProps={{
                                                    style: {padding: 0}
                                                }}
                                                content={
                                                    <Grid item sm={12} xs={12} container>
                                                        <Grid item sm={12} xs={12}>
                                                            <List style={{ margin: '0px 10px 20px' }}>
                                                                <ListItem className={classes.eventListItem}
                                                                          disableGutters>
                                                                    <ListItemText primary={
                                                                        (event.EventVenueName || '') + ((event.EventVenueName)&&', ') + (event.Add1 || event.Add2) + ((event.Add1 || event.Add2)&& ', ') + ((event.City!==null) && event.City) + ((event.City) && ', ') + (event.Region)
                                                                    }

                                                                                  primaryTypographyProps={{
                                                                                      className: classes.eventLocationListItemText
                                                                                  }}
                                                                    />
                                                                </ListItem>
                                                                <ListItem className={classes.eventListItem}
                                                                          disableGutters>
                                                                    <ListItemText
                                                                        primary={"From: " + moment(moment.utc(event.startDateTime,'MM/DD/YYYY hh:mm A').toDate()).local().format('ddd, MMM DD hh:mm A')}
                                                                        className={classes.eventTextRoot}
                                                                        primaryTypographyProps={{
                                                                            className: classes.eventListItemText
                                                                        }}
                                                                    />
                                                                </ListItem>
                                                                <ListItem className={classes.eventListItem}
                                                                          disableGutters>
                                                                    <ListItemText
                                                                        primary={(event.endDateTime !== '') ? "To: " + moment(moment.utc(event.endDateTime,'MM/DD/YYYY hh:mm A').toDate()).local().format('ddd, MMM DD hh:mm A') : "End Date Not Specified"}
                                                                        className={classes.eventTextRoot}
                                                                        primaryTypographyProps={{
                                                                            className: classes.eventListItemText
                                                                        }}
                                                                    />
                                                                </ListItem>
                                                            </List>
                                                        </Grid>
                                                    </Grid>
                                                }
                                                image={event.tempURL || event.LogoURL || EventBG}
                                            />

                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                        {
                            !ownEvents.ownEventReceived && <div className='text-center'><Loader/></div>
                        }
                    </div>
                }

            />
        )
    }
}

const mapStateToProps=(state)=> {
    return {
        ownEvents:state.ownEvents,
    }
};
export default connect(mapStateToProps,null)(withStyles(styles)(EventWebView));